import { computed, type Ref } from 'vue'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { api } from './client'
import type { components } from './types'
import type { PursuitFilters } from '@/composables/usePursuitFiltersUrl'

export type PursuitRankerResponse = components['schemas']['PursuitRankerResponse']
export type PursuitRankerItem = components['schemas']['PursuitRankerItem']
export type PursuitPlateDetailResponse = components['schemas']['PursuitPlateDetailResponse']

export interface PlateDetailWindow {
  since: Date
  until: Date
}

export function usePursuitRanker(filters: Ref<PursuitFilters>) {
  return useQuery({
    queryKey: ['pursuit', 'ranker', filters],
    queryFn: async () => {
      const response = await api.get<PursuitRankerResponse>('/pursuit/ranker', {
        params: {
          since: filters.value.since.toISOString(),
          until: filters.value.until.toISOString(),
          page: filters.value.page,
          page_size: filters.value.page_size,
          min_appearances: filters.value.min_appearances,
        },
      })
      return response.data
    },
    // REFETCH-1: скоринг не realtime; 30с вместо 10с снижает нагрузку (полный
    // скан треков + Python-скоринг на каждый интервал на каждого открытого админа).
    refetchInterval: 30_000,
    placeholderData: keepPreviousData,
  })
}

export function usePursuitPlateDetail(plate: Ref<string>, window: Ref<PlateDetailWindow>) {
  return useQuery({
    queryKey: ['pursuit', 'plate', plate, window],
    queryFn: async () => {
      const response = await api.get<PursuitPlateDetailResponse>(
        `/pursuit/plate/${encodeURIComponent(plate.value)}`,
        {
          params: {
            since: window.value.since.toISOString(),
            until: window.value.until.toISOString(),
          },
        },
      )
      return response.data
    },
    enabled: computed(() => !!plate.value),
    staleTime: 60_000,
  })
}
